import Moment from "moment";
import API from "./api";

/**
 * The UltraGreen certification codes and what they mean.
 *
 * Single source of truth is the UGC_CERT_TYPE table in cosahh; this module is
 * the only place in the app that talks to it. Before it existed the map was
 * open-coded three times — in SearchPage's mobile card, in SearchPage's
 * desktop table and in the claim-check SearchSection — and the copies had
 * already drifted apart from the ones on skinlyzer.com.
 */

// Eight static rows: fetch once per page load and share the promise, so three
// call sites rendering in the same pass do not make three requests.
let pending = null;

export function fetchCertTypes() {
  if (!pending) {
    pending = API.get("ugc/cert-types")
      .then((response) => (Array.isArray(response.data) ? response.data : []))
      .catch(() => {
        pending = null;
        return [];
      });
  }
  return pending;
}

/** Test seam. Never call this from application code. */
export function resetCertTypesCache() {
  pending = null;
}

export function findCertType(code, types) {
  if (code === null || code === undefined) return null;
  if (!Array.isArray(types)) return null;
  return types.find((type) => type.code === code) || null;
}

/**
 * UltraGreenCertAuditDate is the date the certification started while it is
 * running, and the date it ended once it is not.
 */
export function certPreposition(status) {
  return status === "ACTIVE" ? "since" : "from";
}

/**
 * Formats a certification audit date for display, or returns null when there
 * is nothing honest to show.
 *
 * Moment(undefined) is Moment() — "now" — and Moment(null).isValid() is also
 * true (it renders the literal string "Invalid date"). Neither is a real
 * audit date, so the raw value must be checked for presence before Moment
 * ever sees it; an isValid() check alone would silently let "now" through.
 */
export function formatCertDate(raw) {
  if (raw === null || raw === undefined) return null;
  if (typeof raw === "string" && raw.trim() === "") return null;

  const parsed = Moment(raw);
  if (!parsed.isValid()) return null;

  return parsed.format("YYYY-MM-DD");
}
